import React, { useState } from 'react'
import Icon from '../icon'
import {
  Accordion,
  AccordionIcon,
  AccordionItem,
  Description,
  Dropdown,
  Title,
  Wrap,
} from './styles'

type Props = {
  'data-qa'?: string
  title: string
  description: string
  defaultChecked?: boolean
  onChange: (event) => any
}

const CollapseCard: React.FC<Props> = (props: Props) => {
  const [isClicked, setIsClicked] = useState<boolean>(props.defaultChecked)
  /* TODO: A animação não foi implementada nesse componente pois ele entrará 
  para a lista de deprecated. A mudança envolvia break changes, e por isso será 
  realizado apenas no novo componente. */

  return (
    <Accordion data-qa={props['data-qa']}>
      <AccordionItem
        onClick={() => setIsClicked(!isClicked)}
        data-qa={props['data-qa'] && `${props['data-qa']}-item`}
      >
        <Wrap>
          <Title>{props.title}</Title>
          <AccordionIcon>
            <Icon
              name={isClicked ? 'remove' : 'add'}
              color={
                isClicked ? 'brandColorPrimaryPure' : 'neutralColorLowDark'
              }
            />
          </AccordionIcon>
        </Wrap>
        {isClicked === true ? (
          <Dropdown
            className={`${isClicked ? 'is-open' : 'is-closed'}`}
            data-qa={props['data-qa'] && `${props['data-qa']}-dropdown`}
          >
            <Description>{props.description}</Description>
          </Dropdown>
        ) : null}
      </AccordionItem>
    </Accordion>
  )
}

CollapseCard.defaultProps = {
  defaultChecked: false,
  title: 'pergunta',
  description: 'resposta',
}

export default CollapseCard
